class Carousel {
    constructor(container, navigationHandler = () => {}) {
        this._containerEle = container;
        this._index = 0;
        this._childrenEles = Array.from(container.children);
        this._navigationHandler = navigationHandler;
        this.count = this._childrenEles.length;
        this.currentEle = this._childrenEles[0];
    }

    show(index) {
        if (typeof index != 'number') {
            throw new TypeError('The `index` argument must be a number');
        }

        this._index = Math.max(0, Math.min(index, this.count - 1));
        const currentEle = this._childrenEles[this._index];
        this._navigationHandler(index, currentEle, this.count);

        // TODO: animation could happen here
        window.requestAnimationFrame(() => {
            this._childrenEles.forEach(ele => {
                ele.style.display = 'none';
            });
            currentEle.style.display = '';
            const imgEle = currentEle.querySelector('img');
            if (imgEle) {
                this._loadLazyImage(imgEle);
            }
        });

        this.currentEle = currentEle;
        this.preload(4);
    }

    previous() {
        this.show(this._mod(this._index - 1, this.count));
    }

    next() {
        this.show(this._mod(this._index + 1, this.count));
    }

    /**
     * Preload `count` images before and `count` images after the current index
     * where `count` is an integer.
     */
    preload(count) {
        if (typeof count != 'number') {
            throw new TypeError('The `count` argument must be a number');
        }

        const totalCount = count * 2;
        const startIndex = this._index - count;
        // Generate a range from `startIndex` of length `totalCount + 1`.
        // and map to get preloadable images
        new Array(totalCount + 1) // +1 to account for the current index
            .fill(startIndex)
            .map((i, idx) => this._mod(i + idx, this.count))
            .sort() // Preload forwards first as this is the usual direction
            .map(i => this._childrenEles[i].querySelector('[data-src]'))
            .filter(ele => ele)
            .forEach(this._loadLazyImage);
    }

    _loadLazyImage(ele) {
        if (ele.src) {
            return;
        }

        if (ele.hasAttribute('data-srcset')) {
            ele.srcset = ele.getAttribute('data-srcset');
            ele.removeAttribute('data-srcset');
        }

        ele.src = ele.getAttribute('data-src');
        ele.removeAttribute('data-src');
    }

    _mod(n, m) {
        return (n % m + m) % m;
    }
}

export default Carousel;



// WEBPACK FOOTER //
// ./lib/Carousel.js